let language = {
    "DIRECT-CHECKOUT-ENTRY-COUPON-ALERT-MISSING-TITLE": "优惠券代码无效",
    "DIRECT-CHECKOUT-ENTRY-COUPON-ALERT-MISSING-CONTENT": "您提供的优惠码无效。请检查并重试。",
    "DIRECT-CHECKOUT-ENTRY-COUPON-ALERT-MAX-TITLE": "优惠券数量超出限制",
    "DIRECT-CHECKOUT-ENTRY-COUPON-ALERT-MAX-CONTENT": "您只能使用一张优惠券。请检查数量并重试。",
    "DIRECT-CHECKOUT-ENTRY-COUPON-ALERT-DUPLICATE-TITLE": "优惠券已被使用",
    "DIRECT-CHECKOUT-ENTRY-COUPON-ALERT-DUPLICATE-CONTENT": "此优惠券已被使用，无法重复使用。抱歉！",
    "DIRECT-CHECKOUT-ENTRY-COUPON-ALERT-REMOVE-TITLE": "删除优惠券代码提醒",
    "DIRECT-CHECKOUT-ENTRY-COUPON-ALERT-REMOVE-CONTENT": "您确定要删除此优惠券代码吗？",
};

export { language }
